const queryKeys = {
  all: () => ['crm'] as const,

  crm: (crm: string) => [...queryKeys.all(), crm] as const,

  employees: {
    all: (crm: string) => [...queryKeys.crm(crm), 'employees'] as const,

    lists: (crm: string) => [...queryKeys.employees.all(crm), 'list'] as const,

    list: (crm: string, filter: unknown) =>
      [...queryKeys.employees.lists(crm), filter] as const,
  },

  refbes: (code: number) => [...queryKeys.crm('anva'), 'refbes', code] as const,
};

export default queryKeys;
